import { Component } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { Translation } from '@app/translate/models/translation';
import { TranslationFormModel } from '@app/translate/models/translation-form-model';
import { StringMap } from '@app/utils/string-map';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormGroupTyped } from 'src/types/typed-forms';
import { TranslationEditFormModel } from '../../models/translation-edit-form-model';
import { PortalTranslateService } from '../../services/portal-translate.service';

interface TranslationEditInput {
  key: string;
}

@UntilDestroy()
@Component({
  selector: 'portal-translation-edit',
  templateUrl: './translation-edit.component.html',
  standalone: false,
})
export class TranslationEditComponent
  extends DialogComponent<TranslationEditInput, void>
  implements TranslationEditInput
{
  public key: string;

  public form: FormGroupTyped<TranslationEditFormModel> = TranslationEditFormModel.formGroup();

  public originalValues: StringMap<string>;

  public resetValue: any;
  public saving: boolean = false;

  public translation: Translation;

  get formOverrides(): UntypedFormArray {
    return this.form.get('overrides') as UntypedFormArray;
  }

  get formTranslations(): UntypedFormArray {
    return this.form.get('translations') as UntypedFormArray;
  }

  constructor(
    private portalTranslateService: PortalTranslateService,
    ngbActiveModal: NgbActiveModal
  ) {
    super(ngbActiveModal);
  }

  ngOnInit() {
    const languageKeys = this.portalTranslateService.languageKeys;

    this.translation = this.portalTranslateService.getTranslation(this.key);
    this.originalValues = this.translation.translations;

    languageKeys.forEach(() => {
      this.formOverrides.push(TranslationFormModel.formGroup());
      this.formTranslations.push(TranslationFormModel.formGroup());
    });

    this.resetValue = TranslationEditFormModel.from({
      key: this.key,
      mode: 'default',
      overrides: this.translation.overrides,
      translations: this.translation.translations,
    });

    this.form.patchValue(this.resetValue);

    this.form
      .get('translations')
      .valueChanges.pipe(untilDestroyed(this))
      .subscribe(() => {
        this.originalValues = TranslationEditFormModel.merge(
          this.translation,
          this.form.getRawValue()
        ).translations;
      });
  }

  public getOriginalTranslation(key: string) {
    return this.translation.translations[key];
  }

  reset() {}

  trigger(submit: boolean) {
    if (submit) {
      const merged = TranslationEditFormModel.merge(this.resetValue, this.form.value);

      const { key, overrides, translations } = merged;
      const translation = new Translation(key, translations, overrides);

      this.portalTranslateService.updateTranslation(translation);
      this.close();
    } else {
      this.dismiss();
    }
  }
}
